import { call, put, select, takeLatest } from 'redux-saga/effects'
import { IOptionsResponse } from '../../../common/common.types'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'
import { getServiceIdSelector } from '../../user/selectors'
import { OptionsService } from '../services/options.service'
import { setVadMotorCurrentWaveformCharacteristicsOptions } from '../store/options.actions'

export function* getVadMotorCurrentWaveformCharacteristicsOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)
  try {
    const response: IOptionsResponse = yield call([
      optionsService,
      optionsService.getVadMotorCurrentWaveformCharacteristicsOptions,
    ])
    const { entity } = response
    yield put(setVadMotorCurrentWaveformCharacteristicsOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getVadMotorCurrentWaveformCharacteristicsOptions() error: ${e}`))
  }
}
export function* getVadMotorCurrentWaveformCharacteristicsOptionsSaga() {
  yield takeLatest(
    [ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS],
    getVadMotorCurrentWaveformCharacteristicsOptions
  )
}
